import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  private networkError$ = new BehaviorSubject<boolean>(false);
  hasNetworkError$ = this.networkError$.asObservable();

  setNetworkError(value: boolean) {
    this.networkError$.next(value);
  }
}
